// Types/TriggerKind.js
// Enum of known trigger sources. Extend this list, never rewrite dispatch logic per kind
// (see TriggerDispatcher._handlers pattern, rk=6c294559-b0b6-4dc0-a4cd-08ddfa7be0c7).
const TriggerKind = Object.freeze({
  ON_DATA_RECEIVED: "onDataReceived",
  ON_TIMER_ELAPSED: "onTimerElapsed",
  ON_CALENDAR_EVENT_FIRED: "onCalendarEventFired",
  ON_CALCULATION_COMPLETED: "onCalculationCompleted",
  ON_VISIBILITY_RESTORED: "onVisibilityRestored",
});

export default TriggerKind;
